import React from 'react';
import * as R from 'ramda';
import useAPI from '@/hooks/useAPI';
import {revenue} from '@/internal/apis/index';
import {RevenueCtx} from '@/contexts';
import Error from '@/internal/components/Error';

const RevenueProvider = ({match, children}) => {
  const {result, error} = useAPI(revenue, {args: [match.params.id]});

  if (error) {
    return <Error error={error} />;
  }

  return (
    <RevenueCtx.Provider value={R.propOr({}, 'data', result)}>
      {children}
    </RevenueCtx.Provider>
  );
};

export default RevenueProvider;
